import Vue from "vue";
import Router from "vue-router";
import store from "../store";
import Login from "@/components/Login";
import BMWLogin from "@/components/BMWLogin";
import KIALogin from "@/components/KIALogin";
import MainContainer from "@/components/container/MainContainer";
import MainMonitoring from "@/components/MainMonitoring";
import MonitoringV2 from "../components/MonitoringV2.vue";
import MonitoringV3 from "../components/MonitoringV3.vue";
import KiaMainContainer from "@/components/container/KiaMainContainer";
import UsageHistory from "@/components/UsageHistory";
import MngrEmployee from "@/components/MngrEmployee";
import MngrDepartment from "@/components/MngrDepartment";
import RegEmployees from "@/components/RegEmployees";
import RegOrder from "@/components/RegOrder";
import SyncOrder from "@/components/SyncOrder";
import SearchOrders from "@/components/SearchOrders";
import OrderMonitoring from "@/components/OrderMonitoring";
import LotteautocareBillingPage from "../components/LotteautocareBillingPage.vue";
import SocarBulkAddOrder from "../components/SocarBulkAddOrder.vue";
import BillingTable from "../components/BillingTable.vue";

Vue.use(Router);

const requireAuth = () => (from, to, next) => {
  const isAuthenticated = store.getters["userAccount/isAuthentication"];
  if (isAuthenticated) {
    return next();
  } else {
    next("/login");
  }
};

const billingVisible = () => (from, to, next) => {
  const isAuthenticated = store.getters["userAccount/isAuthentication"];
  const isBillingPageVisible =
    store.getters["userAccount/isCallBillingPageVisible"];
  if (isAuthenticated) {
    if (isBillingPageVisible) {
      return next();
    } else {
      next("/v2/monitoring");
    }
  } else {
    next("/login");
  }
};

const hasRole = () => (from, to, next) => {
  const role = store.getters["userAccount/userRole"];
  if (role != 10072) return next("/main/usageHistory");
  next();
};

export default new Router({
  mode: "history",
  routes: [
    {
      path: "*",
      component: () => import("@/views/404"),
      hidden: true
    },
    // {
    //   path: '/',
    //   component: MainContainer,
    //   beforeEnter: requireAuth(),
    //   children: [
    //     {
    //       path: 'monitoring',
    //       component: OrderMonitoring,
    //       // beforeEnter: hasRole()
    //     }
    //   ]
    // },
    {
      path: "/monitoring",
      component: MainMonitoring,
      beforeEnter: requireAuth()
    },
    {
      path: "/v2/monitoring",
      component: MonitoringV2,
      beforeEnter: requireAuth()
    },
    {
      path: "/v3/monitoring",
      component: MonitoringV3,
      beforeEnter: requireAuth()
    },
    {
      path: "/billing/lotteautocare",
      component: LotteautocareBillingPage,
      beforeEnter: billingVisible()
    },
    {
      path: "/bulk/order/push",
      component: SocarBulkAddOrder,
      beforeEnter: requireAuth()
    },
    {
      path: "/billing/table",
      component: BillingTable,
      beforeEnter: requireAuth()
    },
    {
      path: "/login",
      alias: "",
      name: "Login",
      component: Login,
      hidden: true
    }
    // {
    //   path: '/main',
    //   component: MainContainer,
    //   beforeEnter: requireAuth(),
    //   children: [
    //     {
    //       path: 'usageHistory',
    //       alias: '',
    //       component: UsageHistory
    //     },
    //     {
    //       path: 'mngrEmployee',
    //       component: MngrEmployee,
    //       beforeEnter: hasRole()
    //     },
    //     {
    //       path: 'mngrDepartment',
    //       component: MngrDepartment,
    //       beforeEnter: hasRole()
    //     },
    //     {
    //       path: 'regEmployees',
    //       component: RegEmployees,
    //       beforeEnter: function(to, from, next) {
    //         if(to.query.deptNo == false)
    //           from();
    //         else
    //           next();
    //       }
    //     }
    //   ]
    // }
    // {
    //   path: '/kia-main',
    //   component: KiaMainContainer,
    //   beforeEnter: requireAuth(),
    //   children: [
    //     {
    //       path: 'monitoring',
    //       component: OrderMonitoring,
    //       beforeEnter: hasRole()
    //     }
    //   ]
    // },
    // {
    //   path: '/bmw',
    //   alias: '',
    //   name: 'bmw',
    //   component: BMWLogin,
    //   beforeEnter: function(to, from, next) {
    //     const isAuthenticated = store.getters['userAccount/isAuthentication'];
    //     console.debug('/bmw - before enter (router) : ' + isAuthenticated)
    //     if(isAuthenticated)
    //       return next('/temp-main');
    //     next();
    //   }
    // },
    // {
    //   path: '/temp-main',
    //   component: MainContainer,
    //   beforeEnter: requireAuth(),
    //   children: [
    //     {
    //       path: 'order',
    //       alias: '',
    //       component: RegOrder
    //     },
    //     {
    //       path: 'searchOrders',
    //       component: SearchOrders,
    //       beforeEnter: hasRole()
    //     },
    //     {
    //       path: 'syncOrder',
    //       component: SyncOrder,
    //       beforeEnter: hasRole()
    //     },
    //     {
    //       path: 'monitoring',
    //       component: OrderMonitoring,
    //       beforeEnter: hasRole()
    //     }
    //   ]
    // },
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js